import { render, staticRenderFns } from "./SSkeletonFormComp.vue?vue&type=template&id=42a528dc&"
import script from "./SSkeletonFormComp.vue?vue&type=script&lang=js&"
export * from "./SSkeletonFormComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports